<template>
	<a
		class="header-main__button button button--secondary"
		:href="link"
		:data-counter="count || null"
	>
		<i :class="`icon icon-${props.icon}`"></i>
		<slot />
	</a>
</template>

<script setup lang="ts">
import { computed } from 'vue';

type CounterType = 'cart' | 'favourites';

interface Props {
	type: CounterType;
	href?: string;
	icon: string;
}

const props = defineProps<Props>();
const store = window.app.store;

const count = computed(() => store.count[props.type] ?? 0);
const link = computed(() => props.href || '#');
</script>
